const nameToShortName = (name: string): string => {
  const words = name.split(' ');

  if (words.length > 1) {
    const firstname = words[0];
    const surename = words[1];
    const letter = surename.charAt(0).toUpperCase();

    return `${firstname} ${letter}.`;
  }

  return name;
};

export { nameToShortName };
